import getLocale from '@/utils/i18n/getLocale';

export const formatList = (
  items: ReadonlyArray<string | number>,
  options?: Intl.ListFormatOptions,
): string => {
  return new Intl.ListFormat(getLocale(), {
    type: 'conjunction',
    ...options,
  }).format(items.map(String));
};
